import ApiProxy from '@/api/request'
import {Api} from '@/api/types'

const apiOptions = {
  //用户登录等
  getUserLogin: 'POST:/user/login:1',//用户登录
  getUserInfo: '/getUserInfo', //获取用户信息
  // 获取图片验证码
  getCaptcha: '/captcha',
  // 核对拼图验证码
  getCheckCaptcha: '/checkCaptcha',
  // 首页
  getHomeIndex: '/home/index',// 首页数据
  recipeStatistic: 'POST:/home/recipeStatistic',// 处方统计
  stockStatistic: 'POST:/home/stockStatistic',// 零售统计
  // 库存
  getInStocksList: 'POST:/stock/list',// 入库管理-列表 POST:/stock/inStocks
  submitInStock: 'POST:/stock/submitInStock',// 入库管理-提交  /stock/submitInStock
  getStockDetail: '/stock/detail',// 查看详情 /stock/detail
  deleteStock: '/stock/delete',// 出入库作废  /stock/delete
  deleteAllocation: '/stock/deleteAllocation',// 调拨单作废   ---------------2.21--LoseStock--替换为--  stock/lose
  deleteLose: '/stock/lose/delete',// 报损单作废  /stock/deleteLose
  auditLose: '/stock/lose/audit',// 报损单审核 /stock/auditLose
  auditStock: '/stock/audit',// 常规出入库审核 /stock/audit
  auditAllocation: '/stock/auditAllocation',// 调拨单审核        ---------------2.21--inventoryStock--替换为--  stock/inventory
  getOutStocksList: 'POST:/stock/list',// 出库管理-列表检索 POST:/stock/outStocks
  submitOutStock: 'POST:/stock/submitOutStock',// 出库管理-提交和编辑 /stock/submitOutStock
  getLosesStockList: 'POST:/stock/lose/list',// 报损单列表 /stock/stockLoses
  submitLoseStock: 'POST:/stock/lose/submit',// 提交报损单 /stock/submitLoseStock
  getLoseDetail: '/stock/lose/detail',// 报损单详情   /stock/loseDetail
  submitInventoryStock: 'POST:/stock/inventory/submit',// 提交盘点单 /stock/submitInventoryStock
  getStockInventorysList: 'POST:/stock/inventory/list',// 盘点单列表  /stock/stockInventorys
  getStockPeopleItem: '/stock/inventory/status',// 查询是否有人盘点 /stock/inventoryStatus
  getInventoryDetail: '/stock/inventory/detail',// 盘点查看详情  /stock/inventoryDetail
  lockStock: '/stock/inventory/start',// 开始盘点  /stock/lockStock
  unlockStock: '/stock/inventory/stop',// 结束盘点 /stock/unlockStock
  getStockAllocationsList: 'POST:/stock/stockAllocations',// 调拨单列表
  getAllocationDetail: '/stock/allocationDetail',// 调拨单详情
  submitAllocationStock: 'POST:/stock/submitAllocationStock',// 提交调拨单
  getMedicineInfo: '/stock/medicineInfo',// 库存药材检索 /stock/medicineInfo
  getCountMedicineCategory: '/stock/inventory/exportMedicineCount',// 药房药材种类数 /stock/countMedicineCategory
  auditInventory: '/stock/inventory/audit',// 历史盘点列表审核 /stock/auditInventory
  deleteInventory: '/stock/inventory/delete',// 盘点单作废  /stock/deleteInventory
  // 药材管理
  getMedicineList: '/medicine/list', // 药材管理
  getMedicine: '/medicine/get', // 检索药材
  getMedicineCount: '/medicine/count', // 获取药材数量
  exportMedicineList: '/medicine/export', // 导出数据
  addMedicine: 'POST:/medicine/add', // 添加药材
  updateMedicine: 'POST:/medicine/update', // 修改药材
  getMedicineLogs: '/medicine/logs', // 查看日志
  getMedicinePrice: '/medicine/detailList', // 查看药材价格  /medicineDetailList
  getMedicineHisCodeInHosp: '/medicine/getMedicineHisCodeInHosp', // 药材管理 - 医院编码 - 获取药材在所有医院的his编码
  searchMedicineDict: '/medicine/searchMedicineDict', // 药材管理 - 字典编码
  relateMedicineHisCode: 'POST:/medicine/relateMedicineHisCode:1', // 药材关联his
  searchHisCode: '/medicine/searchHisCode', // 模糊搜索医院编码
  // 古方对照
  medicineCountMedMedicineMap: '/medicine/countMedMedicineMap', // 未对照数量
  medicinePageMedMedicineMap: '/medicine/pageMedMedicineMap',// 列表
  medicineGetMedicineList: '/medicine/getMedicineList',// 查询药房药材
  medicineMapMedMedicine: '/medicine/mapMedMedicine',// 对照
  medicineGuFangAuto: '/medicine/syncSysDictMedicineMap',// 古方自动对照
  medicineGuFangDictList: '/system/dict/listSysDictMedicineMap',// 古方对照字典
  medicineGuFangDictUpdate: 'POST:/system/dict/updSysDictMedicineMap',// 古方对照更新
  // 药材调价单
  pageMedMedicineTiaoJia: '/medicine/price/pageMedMedicineTiaoJia',// 药材调价单
  listMedMedicineTiaoJiaDetail: '/medicine/price/listMedMedicineTiaoJiaDetail',// 调价单药材明细
  addOrUpdMedicineTiaoJia: 'POST:/medicine/price/addOrUpdMedicineTiaoJia',// 添加或修改调价单
  auditMedMedicine: '/medicine/price/auditMedMedicine',// 调价单审核
  delMedMedicine: '/medicine/price/delMedMedicine',// 调价单作废
  // 处方
  getRecipeListAdmin: 'POST:/recipe/recipeList/list', // 处方列表-管理员 POST:/recipe/listAdmin   ------2.21---recipeList替换为 /recipe/recipeList
  getRecipeListDecoct: 'POST:/recipe/recipeDecoct/list', // 代煎管理-代煎员  /recipe/listDecoct   ----/recipeDecoct 改成 /recipe/recipeDecoct
  getRecipeListDispense: 'POST:/recipe/recipeDispense/list', // 配药管理-配药员 POST:/recipe/listDispense
  getRecipeListPost: 'POST:/recipe/recipePost/list', // 配送管理-配送员 POST:/recipe/listPost     -----------/recipePost 改成 /recipe/recipePost
  getRecipeCount: '/recipe/countAll?storeId=1', // 处方列表-统计
  getRecipeDetail: '/recipe/recipeList/detail', // 处方药材  /recipe/detail
  getRecipeOne: '/recipe/recipeList/getOne', // 获取处方详情 /recipe/getOne
  getRecipeTimeAxis: '/recipe/recipeList/timeAxis', // 处方时间轴  /recipe/timeAxis
  getRecipeOptLogs: '/recipe/recipeList/optLogs', // 处方日志  /recipe/optLogs
  recipeDispense: '/recipe/recipeDispense/dispense', // 处方配药 /recipe/dispense
  recipeDecoct: '/recipe/recipeDecoct/decoct', // 处方代煎  /recipe/decoct
  recipePost: '/recipe/recipePost/post', // 处方发货 /recipe/post
  addRecipe: 'POST:/recipe/add', //  保存处方订单
  takeRecipe: '/recipe/take', // 取药
  getDoctorInfo: '/recipe/recipeList/getDoctorInfo', // 医生信息  /recipe/getDoctorInfo
  getRecipeCountAdmin: '/recipe/recipeList/count', // 统计---处方列表 /recipe/countAdmin
  getRecipeCountDispense: '/recipe/recipeDispense/count', // 统计---配药列表 /recipe/countDispense   -----/recipeDispense 改成 /recipe/recipeDispense
  getRecipeCountDecoct: '/recipe/recipeDecoct/count', // 统计---代煎列表 /recipe/countDecoct
  getRecipeCountPost: '/recipe/recipePost/count', // 统计---配送列表  /recipe/countPost
  getAuditPost: 'POST:/recipe/recipeAuth/list', // 审核列表 POST:/recipe/listAudit  ----------------recipeAuth 替换为 /recipe/recipeAuth
  getAuditor: '/recipe/recipeAuth/listAuditor', // 审批人列表  /recipe/listAuditor
  getlistDoctorHosp: '/recipe/recipeAuth/listDoctorHosp', // 机构列表 /recipe/listDoctorHosp
  getAudit: '/recipe/recipeAuth/audit', // 审核   /recipe/audit
  // 系统设置 -- 药房管理
  getStoreList: '/system/store/list', // 药房列表
  getStoreAdd: 'POST:/system/store/add', // 添加药房
  upDataStore: 'POST:/system/store/update', // 药房修改
  pageMedStoreLog: '/system/store/pageMedStoreLog', // 药房结算比例日志
  storeDel: 'POST:/system/store/del:1', // 药房删除
  // 系统设置 -- 角色管理
  getRoleList: '/system/role/list', // 角色管理
  getRoleAdd: 'POST:/system/role/add', // 角色添加
  upDataRole: 'POST:/system/role/update', // 角色修改
  roleDel: 'POST:/system/role/del:1', // 角色删除
  roleFuncList: '/system/role/funcList', // 权限列表
  roleSaveFunc: 'POST:/system/role/saveFunc', // 权限保存
  getFunc: '/system/role/getFunc', // 权限回显
  // 系统设置 -- 员工管理
  getUserList: '/system/user/list', // 用户列表
  getUserAdd: 'POST:/system/user/add', // 用户添加
  getUserUpdate: 'POST:/system/user/update', // 用户修改
  upDatePass: 'POST:/updatePass:1', // 修改密码
  delUserInfomation: 'POST:/system/user/del:1', // 员工刪除
  // 系统设置 -- 供应商管理
  supManagement: 'POST:/system/supplier/list', // 供应商列表 /supplier/pageList
  addManagement: 'POST:/system/supplier/addUpd', // 供应商添加 -----2021.2.21----/supplier 替换为  /system/supplier
  delManagement: 'DELETE:/system/supplier/delete:1', // 供应商刪除
  updValidManagement: '/system/supplier/updValid', // 供应商状态更改
  // getSupplierList: '/stock/supplierList', // 获取供应商列表
  // 系统设置 -- 字典管理
  getDictList: '/medicineDict/list', // 字典管理列表
  getDictAdd: 'POST:/medicineDict/add', // 字典管理添加
  // 报表管理 --销售汇总表
  getReportGroupList: '/report/countRecipeGroupByMedicine', // 汇总列表
  getExportCountRecipe: '/report/exportCountRecipeGroupByMedicine', // 导出
  // 报表管理 --销售明细表
  getMedicineSaleList: '/report/countMedicineSaleDetail', // 明细列表
  getExportCountMedicineSale: '/report/exportCountMedicineSaleDetail', // 导出
  getSysUserWithFunc: '/report/getSysUserWithFunc', // 获取经办人列表
  getRecipeDoctor: '/report/getRecipeDoctor', // 查询开方医生列表
  // ---报表管理 --整体运营一览表列表
  getCountRecipeGroupByHosp: '/report/countRecipeGroupByHosp', // 整体运营一览表列表
  getCountDoctorHosp: '/report/countDoctorHosp', //获取县乡村
  getDoctorHosp: '/report/getDoctorHosp', //获取机构列表
  getCountRecipeGroupByDoctor: '/report/countRecipeGroupByDoctor', //  机构绩效汇总表
  getCountAchievementsOneDoctor: '/report/countAchievementsOneDoctor', //  单个医生绩效
  getCountGetMedicinalRecipeBy: '/report/countGetMedicinalRecipeBy', //  单个医生开方明细表
  getMedicinalRecipeDetailList: '/report/getMedicinalRecipeDetailList', //  处方药材明细
  // ---报表管理 --药房销售汇总表
  getCountRecipeGroupBySysStore: '/report/countRecipeGroupBySysStore', //  药房销售汇总表
  getSysStoreList: '/report/getSysStoreList', //  财务汇总报表
  // ---报表管理 --财务汇总报表
  getReportStatistic: '/report/reportStatistic' //  财务汇总报表
}
let str = ''
let arr = JSON.parse(JSON.stringify(apiOptions))
for(let i in arr){
  if (arr[i].charAt(0) == 'P'){
    str += 'export const '+ i + ' = (data) => {\n' +
      '  return request.post(\'' +arr[i].substring(5) + '\', data )\n' +
      '}\n' + '// \n'
  }else if (arr[i].charAt(0) == 'D'){
    str += 'export const '+ i + ' = (params) => {\n' +
      '  return request.delete(\'' +arr[i].substring(7) + '\', { params })\n' +
      '}\n' + '// \n'
  } else {
    str += 'export const '+ i + ' = (params) => {\n' +
      '  return request.get(\'' +arr[i] + '\', { params })\n' +
      '}\n' + '// \n'
    // console.log( 'export const '+ i + ' = (params) => {\n' +
    //   '  return request.get(\'' +arr[i] + '\', { params })\n' +
    //   '}'
    // )
  }

}

// console.log(str)

const $api = new ApiProxy(apiOptions);

export default $api as Api
